export const URL = "https://ndl.education.gov.in/apis";